import React, { useRef, useEffect } from "react";

const RateCanvas = ({ rates, legendMode = false }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Очистка холста
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Установка фона
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Цвет текста
    ctx.fillStyle = "#000";

    // 1. Vote KP (слева сверху)
    ctx.font = "10px Arial";
    const voteKPText = legendMode
      ? "kp"
      : rates.vote_kp
      ? rates.vote_kp.toLocaleString("ru-RU").replace(/,/g, " ")
      : "--";
    ctx.fillText(voteKPText, 5, 10);

    // 2. Rate KP (слева снизу)
    ctx.font = "14px Arial";
    const rateKPText = legendMode
      ? "rate"
      : rates.rate_kp
      ? Number(rates.rate_kp).toFixed(1)
      : "--";
    ctx.fillText(rateKPText, 5, canvas.height - 2);

    // 3. Age (по центру снизу)
    ctx.font = "14px Arial";
    const ageText = legendMode ? "age" : rates.age ? `${rates.age}` : "--";
    const ageWidth = ctx.measureText(ageText).width;
    ctx.fillText(ageText, canvas.width / 2 - ageWidth / 2, canvas.height - 8);

    // 4. Vote IMDB (справа сверху)
    ctx.font = "10px Arial";
    const voteIMDBText = legendMode
      ? "imdb"
      : rates.vote_imdb
      ? rates.vote_imdb.toLocaleString("ru-RU").replace(/,/g, " ")
      : "--";
    const voteIMDBWidth = ctx.measureText(voteIMDBText).width;
    ctx.fillText(voteIMDBText, canvas.width - voteIMDBWidth - 5, 10);

    // 5. Rate IMDB (справа снизу)
    ctx.font = "14px Arial";
    const rateIMDBText = legendMode ? "rate" : rates.rate_imdb || "--";
    const rateIMDBWidth = ctx.measureText(rateIMDBText).width;
    ctx.fillText(
      rateIMDBText,
      canvas.width - rateIMDBWidth - 5,
      canvas.height - 2
    );
  }, [rates, legendMode]);

  return (
    <canvas
      ref={canvasRef}
      width={110}
      height={25}
      style={{ border: "1px solid #000" }}
    />
  );
};

export default RateCanvas;
